module.exports = __webpack_public_path__ + "img/project.6f4b4903.png";